// removed by extract-text-webpack-plugin
module.exports = {"absolute-center":"onfido-sdk-ui-Camera-Permissions/Primer-absolute-center","text":"onfido-sdk-ui-Camera-Permissions/Primer-text","image":"onfido-sdk-ui-Camera-Permissions/Primer-image","reasons":"onfido-sdk-ui-Camera-Permissions/Primer-reasons","reason":"onfido-sdk-ui-Camera-Permissions/Primer-reason","graphic":"onfido-sdk-ui-Camera-Permissions/Primer-graphic","allow":"onfido-sdk-ui-Camera-Permissions/Primer-allow"};


//////////////////
// WEBPACK FOOTER
// ./components/Camera/Permissions/Primer/style.css
// module id = 303
// module chunks = 1